<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item class="count-data">
                    <i class="el-icon-s-data" style="margin-right: 10px;"></i>
                    设计部门总数：{{deparmentCount}}
                    <span style="padding-left: 10px;"
                          v-if="showPersonal">丨&nbsp;&nbsp;{{userName}}个人总数：{{personalCount}}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="客户姓名">
                    <el-input v-model="dataForm.cusName" placeholder="请输入客户姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="设计师">
                    <el-select v-model="dataForm.designId"
                               @focus="setHidden"
                               @blur="setHidden"
                               filterable
                               placeholder="请选择" clearable>
                        <el-option
                                v-for="item in designList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="dataForm.cusPhone" placeholder="请输入手机号码" clearable></el-input>
                </el-form-item>
                <el-form-item label="小区地址">
                    <el-input v-model="dataForm.cusArea" placeholder="请输入小区地址" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="addOrUpdateHandle()"
                               v-if="isAuth('invite-design-add')">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('invite-design-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                    <el-button type="primary" @click="exportData()">导出数据
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @sort-change="customerSort"
                    @selection-change="selectionChangeHandle"
                    :row-class-name="tableRowClassName"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="cusName"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="客户姓名">
                </el-table-column>
                <el-table-column
                        prop="cusPhone"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="电话">
                </el-table-column>
                <el-table-column
                        prop="cusArea"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="小区">
                </el-table-column>
                <el-table-column
                        prop="houseType"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="户型">
                </el-table-column>
                <el-table-column
                        prop="userName"
                        header-align="center"
                        align="left"
                        width="130"
                        sortable
                        :show-overflow-tooltip="true"
                        label="业务员">
                    <template slot-scope="scope">
                        <span v-if="scope.row.userName!==''">{{scope.row.userName}}</span>
                        <span v-if="scope.row.userName!==''&&scope.row.tugou!==''">丨</span>
                        <span v-if="scope.row.tugou!==''">{{scope.row.tugou}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="design"
                        header-align="center"
                        align="center"
                        width="100"
                        sortable
                        :show-overflow-tooltip="true"
                        label="设计师">
                </el-table-column>
                <el-table-column
                        prop="state"
                        header-align="center"
                        align="center"
                        width="120"
                        :sortable="'custom'"
                        :show-overflow-tooltip="true"
                        label="客户情况">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state===1" color="rgba(237,248,6,0.2)"
                                style="color: #DFE506; border-color: #F7F9A4;">方案
                        </el-tag>
                        <el-tag v-if="scope.row.state===2" type="danger">意向金</el-tag>
                        <el-tag v-if="scope.row.state===3" type="warning">定金</el-tag>
                        <el-tag v-if="scope.row.state===4" type="success">80%货款</el-tag>
                        <el-tag v-if="scope.row.state===5">全款</el-tag>
                        <el-tag v-if="scope.row.state===6" type="info">退款</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="备注">
                    <template slot-scope="scope">
                        <span>{{scope.row.remark===''?'暂无':scope.row.remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="signTime"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="签约时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   v-if="isAuth('invite-design-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   v-if="isAuth('invite-design-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <invite-design-add-or-update v-if="addOrUpdateVisible" ref="inviteDesign"
                                     @getDataList="getDataList()"></invite-design-add-or-update>
    </div>
</template>

<script>
    import {InviteDesign} from "../../api/inviteDesign";
    import {UdUser} from "../../api/udUser";
    import InviteDesignAddOrUpdate from './invite-design-add-or-update';
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-design",
        data() {
            return {
                dataForm: {
                    cusName: '',
                    designId: '',
                    cusPhone: '',
                    cusArea: '',
                    column: '',
                    order: ''
                },
                userList: [],
                designList: [],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                showPersonal: false,
                personalCount: '',
                deparmentCount: ''
            }
        },
        computed: {
            userName() {
                let designList = this.designList;
                let current = this.dataForm.designId;
                for (let i = 0; i < designList.length; i++) {
                    if (designList[i].value === current) {
                        //console.log(userList[i].label);
                        return designList[i].label;
                    }
                }
                return '';
            }
        },
        components: {
            InviteDesignAddOrUpdate
        },
        created() {
            this.getDataList();
            this.getUserList();
        },
        activated() {
            this.getDataList();
            this.getUserList();
        },
        watch: {
            'dataForm.designId': {
                handler(newValue, oldValue) {
                    if (newValue === '') {
                        this.setHidden();
                    }
                }
            }
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (row.state === 6) {
                    return 'info-row';
                }
                return '';
            },
            setHidden() {
                this.showPersonal = false;
            },
            /**
             * 自定义排序（客户情况）
             **/
            customerSort(obj) {
                this.dataForm.column = obj.prop;
                this.dataForm.order = obj.order;
                this.getDataList('search');
            },
            //数据导出
            exportData() {
                let sheet = '设计部邀约客户数据' + DateFormat.dateFormat(new Date());
                let columns = [
                    {key: 'id', title: '编号'},
                    {key: 'cusName', title: '客户姓名'},
                    {key: 'cusPhone', title: '电话'},
                    {key: 'cusArea', title: '小区'},
                    {key: 'houseType', title: '户型'},
                    {key: 'style', title: '风格'},
                    {key: 'userName', title: '业务员'},
                    {key: 'design', title: '设计师'},
                    {key: 'state', title: '客户情况'},
                    {key: 'signTime', title: '签约时间'},
                    {key: 'remark', title: '需求备注'},
                    {key: 'creationDate', title: '创建时间'}
                ];
                InviteDesign.getIvDesigns().then(res => {
                    if (res.code === 0) {
                        let exportList = res.designList;
                        this.Excel.exportExcel(columns, exportList, sheet);
                    } else {
                        this.$message.info('数据太多无法导出，请联系管理员！')
                    }
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        this.designList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 7) { // 获取销售部人员
                                this.userList.push(item);
                            }
                            if (item.deparment === 6) { // 获取设计师
                                this.designList.push(item);
                            }
                        });
                    }
                })
            },
            /**
             * 获取数据
             * @param type
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'cusName': this.dataForm.cusName,
                    'designId': this.dataForm.designId,
                    'cusPhone': this.dataForm.cusPhone,
                    'cusArea': this.dataForm.cusArea,
                    'column': this.dataForm.column,
                    'order': this.dataForm.order
                };
                InviteDesign.getIvDesignList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                        if (this.dataForm.designId) {
                            this.showPersonal = true;
                            this.personalCount = res.page.totalCount;
                        } else {
                            this.showPersonal = false;
                            this.deparmentCount = res.page.totalCount;
                        }
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.inviteDesign.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除邀约客户信息, 确定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    InviteDesign.deleteIvDesign(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style>

    .count-data {
        margin: 5px 0;
    }

    .count-data /deep/ .el-breadcrumb__inner {
        color: #606266;
        padding-left: 10px;
        font-size: 18px;
        letter-spacing: 1px;
    }

    .count-data /deep/ .el-breadcrumb__inner:hover {
        color: black;
    }

    .el-table .info-row {
        /*background: #F4F5F7;*/
        color: #909399;
    }

</style>
